import cloneDeep from "lodash/cloneDeep";
import { convertColor } from "../lib/utils";

export const convertColorToLottieColor = (
  color: string | number[] | undefined
) => {
  if (typeof color === "string") {
    const rgb = convertColor(color, "rgb");

    if (!rgb || typeof rgb !== "string") {
      throw new Error("Invalid color " + color);
    }

    const result = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);

    if (!result) {
      throw new Error("Color can be only hex or rgb array (ex. [10,20,30])");
    }

    return [
      Math.round((parseInt(result[1], 10) / 255) * 100) / 100,
      Math.round((parseInt(result[2], 10) / 255) * 100) / 100,
      Math.round((parseInt(result[3], 10) / 255) * 100) / 100,
    ];
  } else if (
    typeof color === "object" &&
    color.length === 3 &&
    color.every((item) => item >= 0 && item <= 255)
  ) {
    return [
      Math.round((color[0] / 255) * 100) / 100,
      Math.round((color[1] / 255) * 100) / 100,
      Math.round((color[2] / 255) * 100) / 100,
    ];
  } else if (!color) {
    return undefined;
  } else {
    throw new Error("Color can be only hex or rgb array (ex. [10,20,30])");
  }
};

function replaceLottieColor(
  sourceLottieColor: number[],
  targetLottieColor: number[],
  obj: any
) {
  // Skip null and undefined values
  if (obj === null || obj === undefined) {
    return obj;
  }

  // Process color nodes directly
  if (obj.c && obj.c.k) {
    // Check if obj.c.k is an array with RGB values
    if (
      Array.isArray(obj.c.k) &&
      obj.c.k.length >= 3 &&
      Math.abs(sourceLottieColor[0] - obj.c.k[0]) < 0.01 &&
      Math.abs(sourceLottieColor[1] - obj.c.k[1]) < 0.01 &&
      Math.abs(sourceLottieColor[2] - obj.c.k[2]) < 0.01
    ) {
      obj.c.k = [...targetLottieColor];
    }
  }

  // Handle arrays
  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      if (typeof obj[i] === "object") {
        replaceLottieColor(sourceLottieColor, targetLottieColor, obj[i]);
      }
    }
  }
  // Handle objects
  else if (typeof obj === "object") {
    for (const key in obj) {
      if (typeof obj[key] === "object") {
        replaceLottieColor(sourceLottieColor, targetLottieColor, obj[key]);
      }
    }
  }

  return obj;
}

export const replaceColor = (
  sourceColor: string | number[],
  targetColor: string,
  lottieObj: any
) => {
  const genSourceLottieColor = convertColorToLottieColor(sourceColor);

  const genTargetLottieColor = convertColorToLottieColor(
    convertColor(targetColor, "hex")
  );

  if (!genSourceLottieColor || !genTargetLottieColor) {
    throw new Error("Proper colors must be used for both source and target");
  }

  return replaceLottieColor(
    genSourceLottieColor,
    genTargetLottieColor,
    cloneDeep(lottieObj)
  );
};
